<template>
  <div style="height: 100%">
    <v-card
      :color="backgroundColor"
      :style="{ width: '100%', margin: 'auto', textAlign: 'center', height: height }"
    >
      <h1 class="mb-5" @click="focusBarcode()">{{ title }}</h1>
      <img
        src="@/../public/img/barcode.png"
        alt
        :style="{ width: '50%' }"
        @click="focusBarcode()"
      />
      <h2 class="mt-5" @click="focusBarcode()">{{ subtitle }}</h2>
      <v-form @submit.prevent="search">
        <v-text-field
          :style="{ textAlign: 'center', width: '50%' }"
          centered
          ref="barcode"
          v-model="barcodeValue"
          class="mx-auto"
          color="secondary"
          single-line
          @keydown.tab="search"
        />

        <v-btn color="secondary" type="submit" :disabled="!barcodeValue">{{
          buttonText
        }}</v-btn>
        <v-btn v-if="extraButtonText" @click="$emit('extraAction')">{{
          extraButtonText
        }}</v-btn>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import LoginCheck from "@/mixins/LoginCheck";

export default {
  name: "barcode",

  props: {
    title: { type: String, default: "Barcode Scan" },
    subtitle: { type: String, default: "Scan or Type" },
    buttonText: { type: String, default: "Search" },
    extraButtonText: { type: String },
    returnTo: { type: String },
    backgroundColor: { type: String, default: "primary" },
    height: { type: String, default: "750px" },
  },

  data() {
    return {
      barcodeValue: "",
    };
  },

  mounted() {
    this.barcodeValue = "";
    this.focusBarcode();
  },

  mixins: [LoginCheck],

  watch: {
    barcodeValue(val) {
      if (!val) {
        this.focusBarcode();
        this.$emit("cleared");
      }
    },
  },

  computed: {},

  methods: {
    focusBarcode() {
      this.$refs.barcode.focus();
      this.barcodeValue = "";
    },

    search() {
      this.$emit("search", this.barcodeValue);
    },
  },
};
</script>
